/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setScheduleScrollbar.js
 * PC向けカスタム横スクロールバー
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

const PC_MEDIA_QUERY = '(min-width: 769px)';

function setScheduleScrollbar() {
	const wrapper = document.querySelector('.js-schedule-scroll');
	const scrollbar = document.querySelector('.js-schedule-scrollbar');
	const track = document.querySelector('.js-schedule-scrollbar-track');
	const thumb = document.querySelector('.js-schedule-scrollbar-thumb');

	if (!wrapper || !scrollbar || !track || !thumb) return;

	const pcMedia = window.matchMedia(PC_MEDIA_QUERY);
	let isDragging = false;
	let startX = 0;
	let startScrollLeft = 0;

	const getMetrics = () => {
		const { scrollWidth, clientWidth, scrollLeft } = wrapper;
		const trackWidth = track.clientWidth;
		const thumbWidth = Math.max((clientWidth / scrollWidth) * trackWidth, 48);
		const maxThumbLeft = Math.max(trackWidth - thumbWidth, 0);
		const maxScrollLeft = Math.max(scrollWidth - clientWidth, 0);

		return {
			scrollWidth,
			clientWidth,
			scrollLeft,
			trackWidth,
			thumbWidth,
			maxThumbLeft,
			maxScrollLeft,
		};
	};

	const update = () => {
		if (!pcMedia.matches) {
			scrollbar.hidden = true;
			return;
		}

		const metrics = getMetrics();

		if (metrics.scrollWidth <= metrics.clientWidth) {
			scrollbar.hidden = true;
			return;
		}

		scrollbar.hidden = false;
		thumb.style.width = `${metrics.thumbWidth}px`;

		const thumbLeft =
			metrics.maxScrollLeft > 0
				? (metrics.scrollLeft / metrics.maxScrollLeft) * metrics.maxThumbLeft
				: 0;

		thumb.style.transform = `translateX(${thumbLeft}px)`;
	};

	const onThumbMouseDown = (event) => {
		if (!pcMedia.matches) return;

		isDragging = true;
		startX = event.clientX;
		startScrollLeft = wrapper.scrollLeft;
		thumb.classList.add('is-dragging');
		event.preventDefault();
	};

	const onDocumentMouseMove = (event) => {
		if (!isDragging) return;

		const metrics = getMetrics();
		if (metrics.maxThumbLeft === 0) return;

		const deltaX = event.clientX - startX;
		const scrollDelta = (deltaX / metrics.maxThumbLeft) * metrics.maxScrollLeft;

		wrapper.scrollLeft = startScrollLeft + scrollDelta;
	};

	const onDocumentMouseUp = () => {
		if (!isDragging) return;

		isDragging = false;
		thumb.classList.remove('is-dragging');
	};

	const onTrackMouseDown = (event) => {
		if (!pcMedia.matches || event.target === thumb) return;

		const metrics = getMetrics();
		if (metrics.maxScrollLeft === 0) return;

		const rect = track.getBoundingClientRect();
		const clickX = event.clientX - rect.left;
		const targetThumbLeft = Math.max(
			0,
			Math.min(clickX - metrics.thumbWidth / 2, metrics.maxThumbLeft)
		);

		wrapper.scrollLeft =
			(targetThumbLeft / metrics.maxThumbLeft) * metrics.maxScrollLeft;
	};

	wrapper.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update);
	pcMedia.addEventListener('change', update);
	thumb.addEventListener('mousedown', onThumbMouseDown);
	track.addEventListener('mousedown', onTrackMouseDown);
	document.addEventListener('mousemove', onDocumentMouseMove);
	document.addEventListener('mouseup', onDocumentMouseUp);

	const img = wrapper.querySelector('img');
	if (img && !img.complete) {
		img.addEventListener('load', update);
	}

	update();
}

export { setScheduleScrollbar };
